<mat-form-field [appearance]="appearance()" class="category-multi-select">
  <mat-label>{{ labelKey() | translate }}</mat-label>
  <mat-select [formControl]="selectControl" multiple (blur)="onTouched()">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="filterControl"
        [placeholderLabel]="'common.search' | translate"
        [noEntriesFoundLabel]="'category-multi-select.no-matching' | translate"
      ></ngx-mat-select-search>
    </mat-option>
    <mmx-select-all-option
      [control]="selectControl"
      [values]="(categoryIds$ | async) ?? []"
    ></mmx-select-all-option>
    @for (category of (filteredCategories$ | async) ?? []; track category.id) {
      <mat-option [value]="category.id">
        {{ category.label }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
